import { endPointEHF } from './base.config';

export const ehf = {
  get: `${endPointEHF}/ehf`,
  listEndUserStatisticReports: `${endPointEHF}/v1/peppol-reporting/end-user-report`,
  generateEndUserStatisticReports: `${endPointEHF}/v1/peppol-reporting/end-user-report/generate`,
  sendEndUserStatisticReports: `${endPointEHF}/v1/peppol-reporting/end-user-report/send`,
  // transaction
  listTransactionReports: `${endPointEHF}/v1/peppol-reporting/transaction-report`,
  generateTransactionReports: `${endPointEHF}/v1/peppol-reporting/transaction-report/generate`,
  sendTransactionReports: `${endPointEHF}/v1/peppol-reporting/transaction-report/send`,
  // spam suppliers
  listSpamSuppliers: `${endPointEHF}/v2/spam-suppliers`,
  addSpamSuppliers: `${endPointEHF}/v2/spam-suppliers`,
  editSpamSuppliers: `${endPointEHF}/v2/spam-suppliers/:id`,
  deleteSpamSuppliers: `${endPointEHF}/v2/spam-suppliers/:id`,
  listSpamData: `${endPointEHF}/v2/spam-supplier-data`,
  // payment setting global
  getPaymentSettingGlobal: `${endPointEHF}/v2/payment-setting-global`,
  addPaymentSettingGlobal: `${endPointEHF}/v2/payment-setting-global`,
  updatePaymentSettingGlobal: `${endPointEHF}/v2/payment-setting-global/:id`,
  deletePaymentSettingGlobal: `${endPointEHF}/v2/payment-setting-global/:id`,
  // payment settin company
  getPaymentSettingCompany: `${endPointEHF}/v2/payment-setting-company`,
  addPaymentSettingCompany: `${endPointEHF}/v2/payment-setting-company`,
  updatePaymentSettingCompany: `${endPointEHF}/v2/payment-setting-company/:id`,
  deletePaymentSettingCompany: `${endPointEHF}/v2/payment-setting-company/:id`,
};
